// extracted by mini-css-extract-plugin
export default {"pageLayout":"JobDescriptionsFromExternalWebsites-module__pageLayout___C3qMw"};